import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes.js';
import { createSessionGuard } from './guards.js';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(createSessionGuard());

router.afterEach(to => {
  document.title = to.meta?.title || 'KATE Applicant Portal';
});

export default router;
